import moment from "moment";
import { toast } from "view/component/Alert";

export function calculateAge(date) {
  var today = new Date();
  var birthDate = new Date(date); // create a date object directly from `dob1` argument
  var age_now = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age_now--;
  }
  return age_now;
}

export function setAge(d) {
  var b = moment(d);
  var a = new Date();

  a = moment(a);

  var years = a.diff(b, "year");
  b.add(years, "years");

  var months = a.diff(b, "months");
  b.add(months, "months");

  var days = a.diff(b, "days");

  if (years !== 0 && months == 0 && days == 0) {
    return years + " Tahun (Hari Lahir Pasien)";
  } else if (years == 0 && months == 0) {
    return days + " Hari";
  } else if (years == 0 && days == 0) {
    return months + " Bulan";
  } else if (years == 0) {
    return months + " Bulan " + days + " Hari";
  } else {
    return years + " Tahun " + months + " Bulan " + days + " Hari";
  }
}

export function getFlatObject(object) {
  const newObject = {};
  if (!object) return {};
  Object.keys(object).forEach((key) => {
    if (object[key]) {
      if (typeof object[key] !== "object") newObject[key] = object[key];
      else if (Array.isArray(object[key])) newObject[key] = object[key];
      else {
        Object.keys(object[key]).forEach((key2) => {
          newObject[key2] = object[key][key2];
        });
      }
    }
  });
  return newObject;
}

export const getSexString = (number) => {
  switch (number) {
    case 1:
      return "Laki - Laki";
    case 2:
      return "Perempuan";
  }
};

export const getVisitTypeName = (id) => {
  switch (id) {
    case "1":
      return "Lama";
    case "2":
      return "Baru Kalender";
    case "3":
      return "Baru";
  }
};

export const formatReference = (data) => {
  if (!data) return [];
  return { value: data.id, label: data.name, ...data };
};

export const formatClinicReference = (data) => {
  if (!data) return [];
  return {
    value: data.clinic.id,
    label: data.clinic.name,
    child: data.clinic.child,
    ...data,
  };
};

export const formatDate = (date) => moment(date).format("YYYY-MM-DD");

export function setAgeObj(d) {
  var b = moment(d);
  var a = new Date();

  a = moment(a);

  var years = a.diff(b, "year");
  b.add(years, "years");

  var months = a.diff(b, "months");
  b.add(months, "months");

  var days = a.diff(b, "days");

  var res = { y: years, m: months, d: days };

  return res;
}

export function setAgeObjDate(d, vd) {
  var b = moment(d);
  var a = moment(vd);

  a = moment(a);

  var years = a.diff(b, "year");
  b.add(years, "years");

  var months = a.diff(b, "months");
  b.add(months, "months");

  var days = a.diff(b, "days");

  var res = { y: years, m: months, d: days };

  return res;
}

export function IsProtocolHT(array_drugs, patient) {
  // let lisinopril = [92000268, 92000269];
  // let amlodipin = [92000407, 92001058];
  // let hct = [92000778];
  // let captopril = [92000344, 92000773];
  let dt = [array_drugs, patient];
  let protocol_drugs = [
    91883, 91882, 91881, 91768, 91767, 91766, 91765, 91764, 91763, 91762, 91761,
  ];
  let captopril = [
    91885, 91884, 91806, 91805, 91804, 91803, 91802, 91801, 91800, 91799, 91798,
    91797,
  ];

  let protocol = patient.flags.find((a) => a.flag_id == 56);
  let list_prescribe = [];
  let list_captopril = false;
  array_drugs.map((a) => {
    a.details.map((b) => {
      if (protocol_drugs.find((c) => c == parseInt(b.drug_id))) {
        list_prescribe.push(b.drug_id);
      }
      if (captopril.find((c) => c == parseInt(b.drug_id))) {
        list_captopril = true;
      }
    });
  });

  let message = false;
  if (!protocol && list_prescribe.length > 0 && !list_captopril) {
    message = true;
  }

  return message;
}

export function formatDateIndo(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export function setAgeCkg(d) {
  var b = moment(d);
  var a = new Date();

  a = moment(a);
  console.log(d, "ckg");

  var years = a.diff(b, "year");
  b.add(years, "years");

  var months = a.diff(b, "months");
  b.add(months, "months");

  var days = a.diff(b, "days");
  if (months == 0 && days <= 30) {
    toast({
      status: "warning",
      text: "PASIEN MASUK KATEGORI CKG, TAWARKAN CKG UNTUK PASIEN",
      timer: 10000,
    });
  }
}
